const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "StatusName",
		label: "状态",
		columnwidth: 100,
	},
	{
		prop: "VouCode",
		label: "经销商入库单号",
		columnwidth: 130,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 150,
	},
	{
		prop: "VoucherType",
		label: "单据类型",
		columnwidth: 100,
	},
	{
		prop: "Organization",
		label: "一级经销商编号",
		columnwidth: 120,
	},
	{
		prop: "CompanyName",
		label: "一级经销商名称",
		columnwidth: 180,
	},
	{
		prop: "CusCode",
		label: "经销商编号",
		columnwidth: 100,
	},
	{
		prop: "CusName",
		label: "经销商名称",
		columnwidth: 180,
	},
	{
		prop: "ExpressCode",
		label: "运单号",
		columnwidth: 180,
	},
	{
		prop: "WHCode",
		label: "仓库编号",
		columnwidth: 100,
	},
	{
		prop: "WHName",
		label: "仓库名称",
		columnwidth: 180,
	},
	{
		prop: "OWhName",
		label: "调出公司",
		columnwidth: 180,
	},
	{
		prop: "CusCode",
		label: "入库方编号 ",
		columnwidth: 120,
	},
	{
		prop: "CusName",
		label: "入库方名称 ",
		columnwidth: 120,
	},
	{
		prop: "Remark",
		label: "备注",
		columnwidth: 150,
	},
	{
		prop: "DeliveryArea",
		label: "收货区域",
		columnwidth: 160,
	},
	{
		prop: "OrgCode",
		label: "经销商订单号",
		columnwidth: 150,
	},
	{
		prop: "OuterCode",
		label: "外部单据号",
		columnwidth: 130,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 100,
	},
	{
		prop: "CreateTime",
		label: "创建日期",
		columnwidth: 180,
	},
	{
		prop: "OWhName",
		label: "调出公司",
		columnwidth: 130,
	},
	{
		prop: "SourceTypeName",
		label: "单据来源",
		columnwidth: 100,
	},
	{
		prop: "Total",
		label: "总金额",
		columnwidth: 80,
	},
	
	{
		prop: "DamageCode",
		label: "报损出库单号",
		columnwidth: 150, 
	},
	{
		prop: "BuyerName",
		label: "报损付款方",
		columnwidth: 200,
	},
	{
		prop: "TerminalHPName",
		label: "报损终端医院",
		columnwidth: 200,
	},
	
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 200,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 180,
	},
	{
		prop: "VerifierName",
		label: "审核人",
		columnwidth: 100,
	},
	{
		prop: "VerifyTime",
		label: "审核时间",
		columnwidth: 180,
	},
]
export default headerData